import axios from "axios";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";

const GetInitiativeRisks = async (IdeaId, userID) => {
  console.log("GetInitiativeDetail", IdeaId, userID);
  const accessToken = sessionStorage.getItem("access_token");

  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeRisk/GetInitiativeRisks`,
      {
        params: { IdeaId }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative detail:", error);
    throw new Error("Failed to fetch initiative detail");
  }
};

export default GetInitiativeRisks;
